/* eslint-disable no-nested-ternary */
import { useCallback } from 'react';
import { StyleSheet, Image } from 'react-native';
import TextButton from '../elements/TextButton';
import { Text, View } from '../Themed';

export type ValidationScreenParamList = {
  blurb: string;
  imageURL: string;
  textField: string;
  onSubmit?: (response: any) => void;
  toWaitlist?: (response: any) => void;
};

export default function ValidationScreen(props: ValidationScreenParamList) {
  const { blurb, imageURL, textField, onSubmit, toWaitlist } = props;

  const handleSubmit = useCallback(() => {
    if (typeof onSubmit === 'function') {
      onSubmit('DEVICE_IS_VALID');
    }
  }, [onSubmit]); // prevents unnecessary renders

  const handleWaitlist = useCallback(() => {
    if (typeof toWaitlist === 'function') {
      toWaitlist('JOINING_WAITLIST');
    }
  }, [toWaitlist]); // prevents unnecessary renders
  return (
    <View style={styles.container}>
      <View style={styles.promptWrapper}>
        <Text style={styles.promptText}>{textField}</Text>
      </View>
      <Image
        style={{ alignSelf: 'center' }}
        source={{
          uri: imageURL,
          height: 133,
          width: 342.5,
        }}
      />
      <TextButton
        textStyle={{
          fontSize: 20,
          fontWeight: 'bold',
          lineHeight: 25,
          letterSpacing: -0.46,
        }}
        style={styles.buttonWrapper}
        text="Yes, I have an iPhone Pro"
        onPress={handleSubmit}
      />
      <View style={styles.blurbWrapper}>
        <Text style={styles.blurbText}>{blurb}</Text>
      </View>
      <TextButton
        textStyle={{
          fontSize: 20,
          fontWeight: '600',
          lineHeight: 25,
          letterSpacing: -0.29,
          color: '#022041',
        }}
        style={styles.waitlistWrapper}
        text="Join the Waitlist"
        onPress={handleWaitlist}
      />
    </View>
  );
}
ValidationScreen.defaultProps = {
  onSubmit: () => {},
  toWaitlist: () => {},
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignSelf: 'center',
    alignContent: 'center',
    alignItems: 'center',
  },
  promptWrapper: {
    height: 144,
    width: 300,
    marginBottom: 40,
  },
  blurbWrapper: {
    height: 36,
    width: 298,
    marginBottom: 10,
  },
  buttonWrapper: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#31373E',
    backgroundColor: '#F5E3E0',
    borderWidth: 3,
    borderStyle: 'solid',
    borderColor: '#31373E',
    borderRadius: 21,
    width: 300,
    height: 50,
    marginVertical: 24,
    alignSelf: 'center',
  },
  waitlistWrapper: {
    fontSize: 20,
    fontWeight: 'bold',
    borderWidth: 3,
    borderStyle: 'solid',
    borderColor: 'rgba(49,55,62,0.64)',
    borderRadius: 21,
    width: 300,
    height: 50,
    alignSelf: 'center',
  },
  blurbText: {
    textAlign: 'center',
    color: '#14181B',

    fontSize: 15,
    fontWeight: '500',
    letterSpacing: 0,
    lineHeight: 18,
  },
  promptText: {
    color: '#14181B',

    fontSize: 20,
    fontWeight: '500',
    letterSpacing: 0,
    lineHeight: 24,
  },
});
